import { useEffect } from "react";
import { useHeroBackground } from "~/hooks/useHeroBackground";
import type { NextGenTheme } from "~/hooks/useNextGenTheme";
import { useFigureTheme } from "~/pages/manifold-nextgen/hooks/useFigureTheme";
import { setUserProperties } from "~/utils/monitoring";

/** Mirrors the nextgen appearance settings into Mixpanel user and super
 *  properties. Call once, from the nextgen layout. */
export const useAppearanceAnalytics = ({ themeMode, resolvedTheme }: NextGenTheme) => {
  const { heroBackground, hasChosenHeroBackground } = useHeroBackground();
  const { figureThemeChoice } = useFigureTheme();

  useEffect(() => {
    setUserProperties({
      theme_mode: themeMode,
      resolved_theme: resolvedTheme,
      plot_theme: figureThemeChoice,
      home_banner: heroBackground,
      home_banner_chosen: hasChosenHeroBackground,
    });
  }, [themeMode, resolvedTheme, figureThemeChoice, heroBackground, hasChosenHeroBackground]);
};
